import React from 'react'
import 'App.css'
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from "./pages/Login";
import Home from "./pages/Home";
import PrivateRouter from './routers/PrivateRouter';
import OrderList from 'pages/OrderList';
// import AllProjects from 'pages/product/AllProjects';
// banner
import BannerList from 'pages/banner/List';
import AddBanner from 'pages/banner/Add';
import UpdateBanner from 'pages/banner/Update';
// events
import EventList from 'pages/events/List';
import AddEvent from 'pages/events/Add';
import UpdateEvent from 'pages/events/Update';
//users
import UsersList from 'pages/users/UsersList';
import AddUser from 'pages/users/AddUser';
import UpdateUser from 'pages/users/UpdateUser';
import AddCustomer from 'pages/customer/AddCustomer';
import LiveVideoList from 'pages/liveVideo/List';
import AddLiveVideo from 'pages/liveVideo/Add';
// import UpdateCustomer from 'pages/customer/UpdateCustomer';
import BillList from 'components/billing/BillList';
import BillDetails from 'components/billing/BillDetails';
import CorderList from 'pages/orderList/CorderList';
import CreateBill from 'components/billing/CreateBill';
import ListNumber from 'pages/gussingnumbers/ListNumber';
import GameBids from 'pages/gamebids/GameBids'
import Withdrawel from 'pages/orderList/Withdrawel';
import ListPlay from 'pages/customer_play/ListPlay';
import QrCodeList from 'pages/qrcodes/QrCodeList';
import WalletCustomerList from 'pages/customer/WalletCustomerList';
import UserLogin from 'pages/UserLogin';
import QuestionList from 'pages/questions/QuestionList';
import AddQuestions from 'pages/questions/AddQuestions';
import QuestionUpdate from 'pages/questions/QuestionUpdate';

import CategoryList from 'pages/category/CategoryList';
import AddCategory from 'pages/category/AddCategory';
import UpdateCategory from 'pages/category/UpdateCategory';
import AllCustomers from 'pages/customer/AllCustomers';
import AllBlogs from 'pages/blogs/AllBlogs';
import CreateBlog from 'pages/blogs/CreateBlog';
import AllTestimonials from 'pages/testimonials/AllTestimonials';
import CreateTestimonial from 'pages/testimonials/CreateTestimonial';
import DepartmentList from 'pages/department/List';
import AddDepartment from 'pages/department/Add';
import UpdateDepartment from 'pages/department/Update';
import DoctorList from 'pages/doctors/List';
import AddDoctor from 'pages/doctors/Add';
import UpdateDoctor from 'pages/doctors/Update';
import ReportList from 'pages/reports/List';
import AddReport from 'pages/reports/Add';
import UpdateReport from 'pages/reports/Update';
import LeadershipList from 'pages/leadership/List';
import AddLeadership from 'pages/leadership/Add';
import UpdateLeadership from 'pages/leadership/Update';
import SocialMedia from 'pages/sitesetup/socialmedia';
import HolidayCalendar from 'pages/sitesetup/holidaycalendar';
import WebsiteLinks from 'pages/sitesetup/websitelinks';
import Announcements from 'pages/sitesetup/announcements';

// Commercial Service
import CommercialServiceList from 'pages/CommercialService/list';
import AddCommercialService from 'pages/CommercialService/add';
import UpdateCommercialService from 'pages/CommercialService/update';

// Gallery
import GalleryList from 'pages/gallery/List';
import AddGallery from 'pages/gallery/Add';
import UpdateGallery from 'pages/gallery/Update';

function App() {
  return (
    <Router>
      <Routes>
        {/* Public routes — no auth required */}
        <Route path="/signin" element={<Login />} />
        <Route path="/userlogin" element={<UserLogin />} />

        {/* Private routes — protected by PrivateRouter */}
        <Route element={<PrivateRouter />}>
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
          <Route path="/dashboard" element={<Home />} />
          <Route path="/orderlist" element={<OrderList />} />

          {/* Commercial Service */}
          <Route path="/commercial-services" element={<CommercialServiceList />} />
          <Route path="/commercial-services/add" element={<AddCommercialService />} />
          <Route path="/commercial-services/update/:id" element={<UpdateCommercialService />} />

          {/* Site Setup */}
          <Route path="/sitesetup" element={<Navigate to="/sitesetup/social-media" replace />} />
          <Route path="/sitesetup/social-media" element={<SocialMedia />} />
          <Route path="/sitesetup/holiday-calendar" element={<HolidayCalendar />} />
          <Route path="/sitesetup/websitelinks" element={<WebsiteLinks />} />
          <Route path="/sitesetup/announcements" element={<Announcements />} />

          {/* testimonials */}
          <Route path="/testimonials" element={<AllTestimonials />} />
          <Route path="/testimonials/add" element={<CreateTestimonial />} />

          {/* departments */}
          <Route path="/departments" element={<DepartmentList />} />
          <Route path="/departments/add" element={<AddDepartment />} />
          <Route path="/departments/update/:id" element={<UpdateDepartment />} />

          {/* doctors */}
          <Route path="/doctors" element={<DoctorList />} />
          <Route path="/doctors/add" element={<AddDoctor />} />
          <Route path="/doctors/update/:id" element={<UpdateDoctor />} />

          {/* reports (notice / annual report / tender) */}
          <Route path="/reports" element={<ReportList />} />
          <Route path="/reports/add" element={<AddReport />} />
          <Route path="/reports/update/:type/:id" element={<UpdateReport />} />

          {/* leadership */}
          <Route path="/leadership" element={<LeadershipList />} />
          <Route path="/leadership/add" element={<AddLeadership />} />
          <Route path="/leadership/update/:id" element={<UpdateLeadership />} />

          {/* users */}
          <Route path="/users" element={<UsersList />} />
          <Route path="/users/add" element={<AddUser />} />
          <Route path="/users/update/:id" element={<UpdateUser />} />

          {/* Blogs */}
          <Route path="/blogs" element={<AllBlogs />} />
          <Route path="/blogs/add" element={<CreateBlog />} />

          {/* Contact Us */}
          <Route path="/contactus" element={<AllCustomers />} />
          <Route path="/contactus/add" element={<AddCustomer />} />
          <Route path="/customer/wallethistory/:id" element={<WalletCustomerList />} />

          {/* category */}
          <Route path="/category" element={<CategoryList />} />
          <Route path="/category/add" element={<AddCategory />} />
          <Route path="/category/update/:id" element={<UpdateCategory />} />

          {/* banner */}
          <Route path="/banner" element={<BannerList />} />
          <Route path="/banner/add" element={<AddBanner />} />
          <Route path="/banner/update/:id" element={<UpdateBanner />} />

          {/* events */}
          <Route path="/events" element={<EventList />} />
          <Route path="/events/add" element={<AddEvent />} />
          <Route path="/events/update/:id" element={<UpdateEvent />} />

          {/* live video */}
          <Route path="/live-video" element={<LiveVideoList />} />
          <Route path="/live-video/add" element={<AddLiveVideo />} />

          {/* billing */}
          <Route path="/billing" element={<CreateBill />} />
          <Route path="/billing-list" element={<BillList />} />
          <Route path="/billing/details/:id" element={<BillDetails />} />

          {/* customer order list */}
          <Route path="/customerorder" element={<CorderList />} />
          <Route path="/withdrawel" element={<Withdrawel />} />

          {/* guessing number list */}
          <Route path="/gussingnumber" element={<ListNumber />} />

          {/* qr code */}
          <Route path="/qrcode" element={<QrCodeList />} />

          {/* gamebid list */}
          <Route path="/gamebids" element={<GameBids />} />
          <Route path="/gamebidsbycustomer/:id" element={<ListPlay />} />

          {/* Question */}
          <Route path="/questions" element={<QuestionList />} />
          <Route path="/questions/add" element={<AddQuestions />} />
          <Route path="/questions/update/:id" element={<QuestionUpdate />} />

          {/* Gallery */}
          <Route path="/gallery" element={<GalleryList />} />
          <Route path="/gallery/add" element={<AddGallery />} />
          <Route path="/gallery/update/:id" element={<UpdateGallery />} />

          {/* Catch-all for unknown private routes */}
          <Route path="/*" element={<h1>No page available</h1>} />
        </Route>
      </Routes>
    </Router>
  );
}

export default App;
